/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AdultTpnViewerAliases {
  ADULT_TPN_CONTENT_PANEL = 'adult-tpn-content-panel',
  ADULT_TPN_DECK = 'adult-tpn-deck',
  ADULT_TPN_DETAILS_CARD = 'adult-tpn-details-card',
  ADULT_TPN_FOOTER_PANEL = 'adult-tpn-footer-panel',
  ADULT_TPN_VIEWER_CONTEXTUAL_BAR = 'adult-tpn-viewer-contextual-bar',
  ADULT_TPN_VIEWER_LAYOUT = 'adult-tpn-viewer-layout',
  CONTEXTUAL_BAR_ACTION_ADJUST_SPEED = 'contextual-bar-action-adjust-speed',
  CONTEXTUAL_BAR_ACTION_REVERSE = 'contextual-bar-action-reverse',
  CONTEXTUAL_BAR_ACTION_SUSPEND = 'contextual-bar-action-suspend',
  CONTEXTUAL_BAR_ACTION_TERMINATE = 'contextual-bar-action-terminate',
  EXECUTE_TIME_BUTTON = 'execute-time-button',
  EXECUTE_TIME_PANEL = 'execute-time-panel',
  GLOBAL_ACTIONS = 'global-actions',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INTERRUPT_BUTTON = 'interrupt-button',
  PANEL_HEADER = 'panel-header',
}
export { AdultTpnViewerAliases };
